// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TemplateGroupListResolver } from '@services/resolvers/template-group-list.resolver';
import { StartDealJacketComponent } from './start-deal-jacket.component';
import { DealsGuard } from '@services/route-guards/permissions/deals.guard';

const routes: Routes = [
    {
        path: '',
        component: StartDealJacketComponent,
        data: {
            title: 'Start Deal Jacket',
            headerTooltip:
                "Deal Jackets require the buyer's information and VIN at a minimum; there may also be a Co-Buyer and trade-in. Once you have added or updated the buyer and vehicle information, select how you want to add documents to the deal. For details and guidance on starting Deal Jackets, click Learn More on the right side of the screen.",
        },
        resolve: {
            groups: TemplateGroupListResolver,
        },
        canActivate: [DealsGuard],
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ExpressUploadRoutingModule {}
